import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';
import api from '../../utils/api';
import './UserFormPage.css';

const UserFormPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;

  const [form, setForm] = useState({
    username: '',
    password: '',
    name: '',
    email: '',
    role: 'MASTER',
    locationId: '',
  });
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const locRes = await api.get('/locations');
        setLocations(locRes.data);

        if (isEdit) {
          const res = await api.get(`/users/${id}`);
          const u = res.data;
          setForm({
            username: u.username || '',
            password: '',
            name: u.name || '',
            email: u.email || '',
            role: u.role || 'MASTER',
            locationId: u.locationId || '',
          });
        }
      } catch (error) {
        console.error('Failed to fetch data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id, isEdit]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = { ...form };
      if (isEdit && !payload.password) {
        delete payload.password;
      }
      if (isEdit) {
        await api.put(`/users/${id}`, payload);
      } else {
        await api.post('/users', payload);
      }
      navigate('/admin/users');
    } catch (error) {
      console.error('Failed to save user:', error);
      alert(error.response?.data?.error || 'Failed to save user');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <AdminLayout><div className="admin-loading">Loading...</div></AdminLayout>;
  }

  return (
    <AdminLayout>
      <div className="user-form-page">
        <button className="back-btn" onClick={() => navigate('/admin/users')}>
          ← Back to Users
        </button>
        <h1>{isEdit ? 'Edit User' : 'Add User'}</h1>

        <form onSubmit={handleSubmit} className="admin-form">
          <div className="form-section">
            <h3>Account Info</h3>
            <div className="form-grid">
              <div className="form-field">
                <label>Username *</label>
                <input name="username" value={form.username} onChange={handleChange} required disabled={isEdit} />
              </div>
              <div className="form-field">
                <label>{isEdit ? 'New Password (leave empty to keep)' : 'Password *'}</label>
                <input type="password" name="password" value={form.password} onChange={handleChange} required={!isEdit} />
              </div>
              <div className="form-field">
                <label>Name *</label>
                <input name="name" value={form.name} onChange={handleChange} required />
              </div>
              <div className="form-field">
                <label>Email</label>
                <input type="email" name="email" value={form.email} onChange={handleChange} />
              </div>
              <div className="form-field">
                <label>Role *</label>
                <select name="role" value={form.role} onChange={handleChange} required>
                  <option value="MASTER">Master</option>
                  <option value="SUPER_MASTER">Super Master</option>
                </select>
              </div>
              <div className="form-field">
                <label>Assigned Location</label>
                <select name="locationId" value={form.locationId} onChange={handleChange}>
                  <option value="">None (all locations)</option>
                  {locations.map((loc) => (
                    <option key={loc.id} value={loc.id}>{loc.nameEn}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="cancel-btn" onClick={() => navigate('/admin/users')}>Cancel</button>
            <button type="submit" className="save-btn" disabled={saving}>
              {saving ? 'Saving...' : (isEdit ? 'Update' : 'Create')}
            </button>
          </div>
        </form>
      </div>
    </AdminLayout>
  );
};

export default UserFormPage;
